// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__332Vc","Label":"Input_Label__2T-DL","InputElement":"Input_InputElement__2crAS","Invalid":"Input_Invalid__2blfR"};